import React, { Component } from 'react';
import '../css/unsubscribe.css';
import axios from "axios";
import { backendDomain } from "../modules/configs";

export default class UnsubscribePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            usernameEnc: '',
            unsubscribeButtonDisabled: false,
            infoMessage: '',
            errorMessage: ''
        };
    }

    componentDidMount() {
        const query = this.getQuery();
        const username = query.username;
        const usernameEnc = query.usernameEnc;
        if (username && usernameEnc) {
            this.setState({usernameEnc, username})
        } else {
            this.setState({unsubscribeButtonDisabled: true, errorMessage: "Illegal URL!"})
        }
    }

    componentWillUnmount() {
        if (this.messageDelay) {
            clearTimeout(this.messageDelay);
        }
    }

    getQuery = () => {
        const url = decodeURI(this.props.location.search);
        let query = {};
        if (url.indexOf("?") !== -1) {
            const str = url.substr(1);
            const pairs = str.split("&");
            pairs.forEach((item) => {
                const index = item.indexOf("=");
                const key = item.slice(0, index);
                const value = item.slice(index + 1);
                query[key] = value;
            })
        }
        return query;
    };

    async unsubscribe(ev) {
        if (ev) {
            ev.preventDefault();
        }
        this.setState({unsubscribeButtonDisabled: true, errorMessage: ''});
        const {usernameEnc} = this.state;
        if (!usernameEnc) {
            //todo
            return this.errorMessage('Some thing wrong')
        }
        try {
            await axios.post(`${backendDomain}/preference/unsubscribeFromEmail`, {usernameEnc}, {headers: {'Content-Type': 'application/json'}});
            this.infoMessage("Unsubscribe success");
        } catch (e) {
            this.errorMessage("Unsubscribe fail");
        }
    }

    render() {
        return (
            <div className='unsubscribe-page-wrapper'>
                <div className="unsubscribe-page">
                    <form className="unsubscribe-form">
                        {
                            this.state.errorMessage &&
                            <div className='error-message-box alert alert-danger'>
                                <strong>Error: </strong>{this.state.errorMessage}
                            </div>
                        }
                        {
                            this.state.infoMessage &&
                            <div className='info-message-box alert alert-info'>
                                {this.state.infoMessage}
                            </div>
                        }
                        <h4>Unsubscribe</h4>
                        <p>This will stop all emails from <b>SprintRay</b>.</p>
                        <p>Email Address</p>
                        <input type="text" placeholder="Email/Username"
                               value={this.state.username}
                               disabled={true}
                               onChange={(ev) => this.setState({username: ev.target.value})}
                        />
                        <p className="message">
                            If this isn't your email address you haven't been added to any mailing lists and there
                            is no need to unsubscribe.
                        </p>
                        <button onClick={(ev) => this.unsubscribe(ev)} disabled={this.state.unsubscribeButtonDisabled}>
                            Unsubscribe
                        </button>
                        <p className="mini-p">
                            Note: In each email you receive,there will be a link to unsubscribe.
                        </p>
                    </form>
                </div>
            </div>
        );
    }

    errorMessage(msg) {
        this.setState({errorMessage: msg, infoMessage: '', unsubscribeButtonDisabled: false});
        this.fadeTimeout();
    }

    infoMessage(msg) {
        this.setState({infoMessage: msg, errorMessage: ''});
        this.fadeTimeout();
    }

    fadeTimeout = () => {
        clearTimeout(this.messageDelay);
        this.messageDelay = setTimeout(() => {
            this.setState({infoMessage: '', errorMessage: '', unsubscribeButtonDisabled: false})
        }, 3000)
    }

}


// WEBPACK FOOTER //
// ./src/components/unsubscribe_page.js